import { injectable } from 'inversify';

import BaseService from '@core/services/base';

@injectable()
export default class NotificationService extends BaseService {
  static diToken = Symbol('natification-service');

  constructor() {
    super({ domainArea: 'user-accounts' });
  }
}
